


























































































import { Component, Mixins } from 'vue-property-decorator';
import { AxTransparent } from '@/mixins';
// import * as I from '@/interfaces';

// class State {
//   zoneCode: number;
//   selectItem: I.DeviceInfo;
//   searchText: string;
//   selectedList: I.DeviceInfo[];
//   constructor() {
//     this.zoneCode = 0;
//     this.selectItem = { id: 0, name: '' };
//     this.searchText = '';
//     this.selectedList = [];
//   }
// }

@Component
export default class AxDeviceBox extends Mixins(AxTransparent) {
  // state: State = new State();
  // @Prop({ type: Array, default: () => [] })
  // deviceList!: I.DeviceInfo[];
  // get filteredList() {
  //   if (!this.state.searchText.length) return this.deviceList;
  //   const searcher = new Hangul.Searcher(this.state.searchText.trim());
  //   return this.deviceList.filter(x => searcher.search(x.name) !== -1);
  // }
}
